<template>
  <div class="featurenewhtml">
    <div class="featurenewhead">
      <div class="featurenewheadtext">
        <img src="../assets/img/dengp.png" alt="" style="position:relative;top:-5px">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 44px;
            text-align:center;
            display: inline-block;
            vertical-align: bottom;
          "
        >
          功能-期货资管部门的业务管理
        </p>
      </div>
    </div>
    <div class="featurenewbody">
      <div class="featurenewbodytag">
        <ul style="padding-top: 35px">
          <li class="pli" @click="goto('channel')">
            <div v-bind:class="[form.channel ? class1 : class2]" >
              <div class="tagmid">自定义工作流多级审批</div>
            </div>
          </li>
          <li class="pli" @click="goto('position')">
            <div v-bind:class="[form.position ? class1 : class2]" >
              <div class="tagmid">合规留痕</div>
            </div>
          </li>
          <li class="pli" @click="goto('dimension')">
            <div
              v-bind:class="[form.dimension ? class1 : class2]"
            >
              
              <div class="tagmid">产品联合风控方案</div>
              
            </div>
          </li>
          <li class="pli" @click="goto('software')">
            <div v-bind:class="[form.software ? class1 : class2]" >
              
              <div class="tagmid">双语言API接口</div>
              
            </div>
          </li>
        </ul>
      </div>
      <div class="featurenewbodytext" ref="box">
        <div
          style="
            width: 854px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext" >
            <div v-if="form.channel">
                <p class="pproduct">
                    TMS系统提供了角色、产品、工作流等工具，通过角色设置、产品设置、自定义工作流，实现了多级审批，确保交易指令的产生、审批、执行等环节符合相关的合规要求和监管标准。
                </p>
                <p class="pimg"><img src="../assets/feaimg/tu-2.png" alt="" style="width:auto"></p>
                <p class="pproduct">
                    （1）自定义工作流，如下图所示：可按照产品、资金账户、品种类别分别设置工作流。
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP1-1.jpg')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP1-1.jpg'))"/></p>
                <p class="pproduct">
                    （2）投资经理/独立交易员下单面板，如下图所示：支持期货、个股期权、股票和债券等交易。
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP1-2.jpg')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP1-2.jpg'))"/></p>
            </div>
            <div v-if="form.position">
                <p class="pproduct">
                   系统提供了全面的交易数据和操作数据记录功能，包括存储终端的IP、MAC地址等相关信息。这些数据将被永久保存，并且提供了导出功能，便于自检或配合监管部门进行合规性检查。
                </p>
                <p class="pproduct">
                    此外，系统还支持登录白名单控制，可以根据IP和MAC地址分别进行控制。通过配置白名单，在系统登录时只允许来自指定IP或MAC地址的用户接入系统，从而增强系统的安全性和访问控制能力。
                </p>
                <p class="pproduct">
                    （1）留痕查询，如下图所示：
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP2-1.png')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP2-1.png'))"/></p>
                <p class="pproduct">
                    （2）登录白名单管理，如下图所示：
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP2-2.jpg')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP2-2.jpg'))"/></p>
            </div>
            <div v-if="form.dimension">
                <p class="pproduct">
                    系统提供了支持根据相关法律法规和产品发行要求添加产品风控指标，如杠杆率控制、双25%、持仓数量、保证金和持仓市值等。还提供了针对产品层级的净值、当日亏损、总资产和回撤等指标的控制，可制定的产品联合风控方案，为交易保驾护航。
                </p>
                <p class="pproduct">
                    （1）新增产品风控方案，如下图所示：
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP2-3.jpg')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP2-3.jpg'))"/></p>
                <p class="pproduct">
                （2）新增风控指标，如下图所示：
                </p>
                <p class="pimg"><imggs :src="require('../assets/feaimg/TMSP2-4.jpg')" alt="" @click.native="showimg(require('../assets/feaimg/TMSP2-4.jpg'))"/></p>
            </div>
            <div v-if="form.software">
                <p class="pproduct">
                  API接口可支持多种主流编程语言，如C++、Python等，提供了一套简单易用的方法和函数，以及详细的文档和示例代码，使得资管部门能够迅速理解和应用接口功能，从而完成快速而无成本的接入TMS（交易管理系统）进行下单交易。
                </p>
                <div class="mulukuang">
                  <div class="mulu">目录</div>
                  <div style="display:flex">
                    <div>
                      <div class="mulutitle">1.介绍</div>
                      <div class="mulutitle">2.接口模式</div>
                      <div class="mulutext">2.1.对话流和查询流编程接口</div>
                      <div class="mulutext">2.2私有流编程接口</div>
                      <div class="mulutitle">3.开发接口</div>
                      <div class="mulutext">3.1.通用规则</div>
                      <div class="mulutext">3.2.CWHTraderSpi接☐</div>
                      <div class="mulutext">3.3.CWHTraderApi接☐</div>
                      <div class="mulutext">3.4.Python接☐</div>
                    </div>
                    <div style="margin-left:150px">
                      <div class="mulutitle">4.开发注意事项</div>
                      <div class="mulutext">4.1.API实例使用规则</div>
                      <div class="mulutext">4.2.API连接断开处理规则</div>
                      <div class="mulutext">4.3.报单回报回调规则</div>
                      <div class="mulutext">4.4.报单应答接口说明</div>
                      <div class="mulutext">4.5.查询投资者账号接口说明</div>
                      <div class="mulutext">4.6.交易编码说明</div>
                      <div class="mulutext">4.7.请求ID和周边自用编号说明</div>
                      <div class="mulutitle">5.开发示例</div>
                      <div class="mulutext">5.1.交易API开发示例</div>
                      <div class="mulutext">5.2.Python开发示例</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
    <Baseimg :src='src' :show='ifimg' @change="ifimg=false"/>
  </div>
</template>

<script>
import imggs from '../components/imggs'
import Baseimg from '../components/Baseimg.vue';
export default {
  components:{Baseimg,imggs},
  data() {
    return {
      src:'',
      ifimg:false,
      form: {
        channel: true,
        position: false,
        dimension: false,
        software: false,
      },
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
      scroll: "",
    };
  },
  methods: {
    showimg(e){
      this.src=e
      this.ifimg=true
    },
    custormAnchor(anchorName) {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.form[anchorName] = true;
      window.scrollTo(0,0)
    },
    goto(id){
      this.$router.push({ path: `/features/featurenewfof/${id}` });
      this.custormAnchor(id);
    },

  },

  mounted() {
    this.custormAnchor(this.$route.params.id);
  },
};
</script>

<style scoped>
.featurenewhtml {
  background: url("../assets/img/bg-gm.png") no-repeat center top,#e3effb;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.featurenewhead {
  position: relative;
  height: 145px;
  width: 1060px;
  margin: 0 auto;
}
.featurenewheadtext {
  position: absolute;
  top: 90px;
}
.featurenewbody {
  width: 1060px;
  margin: 0 auto;
  position: relative;
  display: flex;
}
.featurenewbodytag {
  width: 730px;
  height: 630px;
  border-radius: 2%;
  background: url("../assets/img/ce.png") no-repeat left top;
}
.featurenewbodytext {
  width: 854px;
  margin-left: -15px;
  margin-top: -5px;
  min-height: 680px;
  border-top-left-radius: 1em;
  background: #f6fbfe;
  background-size: 100%;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  display: inline-block;
}
.noclick {
  height: 55px;
  line-height: 55px;

  width: 220px;
  letter-spacing: 1px;
  color: #cdc6c6;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 55px;
  line-height: 55px;
  background: url(../assets/img/xuan.png)no-repeat left center;

  width: 220px;

  color: #26353a;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #285b6b;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 730px;
  margin: 0 auto;
  padding-top: 38px;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.pimg img {
  width: 666px;
}
.noclick:hover {
  color: #c2edfb;
}
.pli {
  width: 226px;
  height: 55px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}


.tagmid {
  width: 158px;
  
  float: left;
  margin-left: 22px;
  font-weight: bold;
  border-bottom: 1px solid #6179a6;
}
.onclick .tagmid{
  border-bottom: none;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.mulukuang{
  margin-top: 20px;
  padding:20px 40px ;
  border-radius: 8px;
  box-shadow: 0 0 4px 2px #e0e0e0;
  padding-bottom: 45px;
}
.mulu{
  margin-bottom: 20px;
  text-align: left;
  text-indent: 4px;
  color: #e6c387;
  font-size: 20px;
  border-left: 4px solid #e6c387;
  font-weight: bold;
  line-height: 20px;
}
.mulutitle{
  text-align: left;
 font-size: 16px;
 color: #245376;
  text-indent: 0px;
  margin: 15px 0;
  margin-bottom: 6px;
  /* font-weight: bold; */
}
.mulutext{
  text-align: left;
  color: #666666;
  font-size: 14px;
  text-indent: 15px;
  margin: 4px 0;
}
</style>